export const tickCount = 6;
